import {PageToasts} from 'src/app/context/ToastContext'
import {GIconProps} from '../Icon/GIcon'

export const iconSchemeFn = (data: PageToasts): GIconProps => {
  if (data.scheme === 'success') return 'IconCheckCircle'
  if (data.scheme === 'danger') return 'IconExclamation'
  else return 'IconCheckCircle'
}
